import { useEffect } from "react"
import { axiosPrivate } from "../api/axios"
import useRefreshToken from "./useRefreshToken"
import { setSession } from "../contexts/JWTContext"
import { getToken } from "../assets/js/features/token/TokenEncryption"

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useAxiosPrivate = () => {
  const refresh = useRefreshToken()

  useEffect(() => {
    const requestIntercept = axiosPrivate.interceptors.request.use(
      (config) => {
        if (!config.headers["Authorization"]) {
          const serviceToken = getToken()
          config.headers["Authorization"] = `Bearer ${serviceToken}`
        }
        return config
      },
      (error) => Promise.reject(error)
    )

    const responseIntercept = axiosPrivate.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config

        if (
          error?.response?.status === 401 &&
          !prevRequest?.sent &&
          error?.response?.data?.type === "JWT_EXPIRED"
        ) {
          prevRequest.sent = true
          const newAccessToken = await refresh()
          prevRequest.headers["Authorization"] = `Bearer ${newAccessToken}`
          setSession(newAccessToken)
          return axiosPrivate(prevRequest)
        }
        return Promise.reject(error)
      }
    )

    return () => {
      axiosPrivate.interceptors.request.eject(requestIntercept)
      axiosPrivate.interceptors.response.eject(responseIntercept)

      axiosPrivate.interceptors.response.use(
        response => response,
        (error) => {
          throw error
        }
      )

    }
  }, [refresh])

  return axiosPrivate
}

export default useAxiosPrivate
